import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NotificationsState {
  // Bell panel visibility. Lives in redux (not in NavBar state) so it
  // survives the route-tree remounts App.tsx does while roles and
  // settings load, e.g. after the /powiadomienia deep link. Not persisted.
  showPanel: boolean;
}

const initialState: NotificationsState = {
  showPanel: false,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setShowNotificationsPanel: (state, action: PayloadAction<boolean>) => {
      state.showPanel = action.payload;
    },
  },
});

export const { setShowNotificationsPanel } = notificationsSlice.actions;

export default notificationsSlice.reducer;
